<template>
    <div class="headBox">
        <!-- 使用响应式图片 -->
        <img src="@/images/logo.png" alt="logo" class="logo-img">
        <!-- 移动端菜单按钮 -->
        <!-- <div v-if="isMobile" class="menu-button" @click="toggleMenu">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
        </div> -->
        <div class="listBoxCss">
            <div style="cursor: pointer;" :class="acId === item.id ? 'acItemCss' : 'listItemCss'" v-for="item in list"
                :key="item.id" @click="cutPage(item)">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'headComponents',
    data() {
        return {
            list: [
                { id: 1, name: '首页', toUrl: '/home' },
                { id: 2, name: '关于见心', toUrl: '/introduce' },
                { id: 3, name: '产品中心', toUrl: '/product' },
                { id: 4, name: '合作代理', toUrl: '/agency' },
                { id: 5, name: '体验中心', toUrl: '/experience' },
            ],
            acId: 1,
            // isMobile: false,
            // menuVisible: false
        };
    },
    created() {
        if (this.$route.path.includes('home')) {
            this.acId = 1;
        }
        if (this.$route.path.includes('introduce')) {
            this.acId = 2;
        }
        if (this.$route.path.includes('product')) {
            this.acId = 3;
        }
        if (this.$route.path.includes('agency')) {
            this.acId = 4;
        }
        if (this.$route.path.includes('experience')) {
            this.acId = 5;
        }
        // 检测是否为移动端
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
        cutPage(item) {
            this.acId = item.id;
            this.$router.push(item.toUrl);
            // if (this.isMobile) {
            //     this.menuVisible = false;
            // }
        },
        checkMobile() {
            this.isMobile = window.innerWidth < 768;
            // if (!this.isMobile) {
            //     this.menuVisible = false;
            // }
        },
        // toggleMenu() {
        //     this.menuVisible = !this.menuVisible;
        // }
    }
};
</script>

<style lang="less" scoped>
.headBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100vw;
    height: 4.17vw;
    /* 80px / 19.2 */
}

.logo-img {
    width: 100%;
    max-width: 16.88vw;
    /* 324px / 19.2 */
    height: auto;
    margin-left: 13.4vw;

    // @media (max-width: 767px) {
    //     max-width: 10.42vw;
    //     /* 200px / 19.2 */
    //     margin-left: 1.04vw;
    //     /* 20px / 19.2 */
    // }
}

.listBoxCss {
    display: flex;
    align-items: center;
    margin-right: 13.4vw;

    // @media (max-width: 767px) {
    //     display: none;
    //     flex-direction: column;
    //     position: absolute;
    //     top: 4.17vw;
    //     /* 80px / 19.2 */
    //     left: 0;
    //     width: 100%;
    //     background-color: #fff;
    //     z-index: 3;
    // }

    &.show-menu {
        display: flex;
    }
}

.listItemCss {
    width: 7.81vw;
    /* 150px / 19.2 */
    height: 4.17vw;
    /* 80px / 19.2 */
    background-color: #fff;
    text-align: center;
    line-height: 4.17vw;
    /* 80px / 19.2 */
    font-weight: 400;
    font-size: 0.94vw;
    /* 18px / 19.2 */
    color: #323232;

    // @media (max-width: 767px) {
    //     width: 100%;
    // }
}

.acItemCss {
    width: 7.81vw;
    /* 150px / 19.2 */
    height: 4.17vw;
    /* 80px / 19.2 */
    background-color: #0093E8;
    text-align: center;
    line-height: 4.17vw;
    /* 80px / 19.2 */
    font-weight: 400;
    font-size: 0.94vw;
    /* 18px / 19.2 */
    color: #fff;

    // @media (max-width: 767px) {
    //     width: 100%;
    // }
}

.menu-button {
    display: none;

    // @media (max-width: 767px) {
    //     display: block;
    //     margin-right: 1.04vw;
    //     /* 20px / 19.2 */
    //     cursor: pointer;
    // }

    .bar {
        width: 1.56vw;
        /* 30px / 19.2 */
        height: 0.16vw;
        /* 3px / 19.2 */
        background-color: #323232;
        margin: 0.31vw 0;
        /* 6px / 19.2 */
    }
}
</style>